import { GoogleTagManagerSubjectEnums } from '@/enums/tracking.enum';
import { AccountRegistration, GoogleTagManagerTypes, MatomoTypes } from '@/types/tracking.types';

import { useUserStore } from '@/stores/user.store';
import i18n from '@/dependencies/i18n';

const { locale } = i18n.global;

export default {
    // @todo: infer d type by subject
    sendGtm(subject: GoogleTagManagerSubjectEnums, d: any): void {
        switch (subject) {
            case GoogleTagManagerSubjectEnums.Funnel:
                this.pushGtm(this.makeFunnelGtmData(d));
                break;
            case GoogleTagManagerSubjectEnums.GeneralWorkflow:
                this.pushGtm(this.makeGeneralWorkflowData(d));
                break;
            case GoogleTagManagerSubjectEnums.GeneralWorkflowProducts:
                this.pushGtm(this.makeGeneralWorkflowCheckoutData(d));
                break;
            case GoogleTagManagerSubjectEnums.AccountRegistration:
                this.pushGtm(this.makeAccountRegistrationData(d));
                break;
        }
    },

    sendMatomo(subject: string, d: MatomoTypes) {
        switch (subject) {
            case 'funnel':
                this.funnelMatomo(d);
                break;
        }
    },

    funnelMatomo(e: MatomoTypes) {
        const matomo = this.makeFunnelMatomoData(e);
        this.pushMatomo(matomo);
    },

    makeAccountRegistrationData(props: AccountRegistration) {
        return {
            eventCategory: 'bvFunnel',
            eventAction: 'registration',
            eventLabel: 'register',
            ...props,
        };
    },

    makeFunnelGtmData(options: GoogleTagManagerTypes) {
        return {
            event: 'funnelIncorporation',
            eventCategory: 'bvFunnel',
            ...options,
        };
    },

    makeFunnelMatomoData(options: MatomoTypes) {
        return ['setEcommerceView', options?.sku || false, options?.product || false, options?.category || null, options?.price || null].filter((o) => o);
    },

    makeGeneralWorkflowCheckoutData(d) {
        return {
            event: 'begin_checkout',
            ...d,
        };
    },

    makeGeneralWorkflowData(d) {
        const { sessionId, user, type } = useUserStore();
        return {
            event: 'checkout',
            section: 'checkout',
            loggedIn: !!sessionId,
            userId: user?.id,
            clientType: type,
            language: locale.value,
            ...d,
        };
    },

    pushGtm(data: any) {
        if (!this.hasGtm()) {
            return;
        }

        globalThis.dataLayer.push(data);
    },

    pushMatomo(data: any) {
        if (!this.hasMatomo()) {
            return;
        }

        globalThis._paq.push(data);
        globalThis._paq.push(['trackPageView']);
    },

    hasGtm() {
        return globalThis.dataLayer && globalThis.dataLayer.push;
    },

    hasMatomo() {
        return globalThis._paq && globalThis._paq.push;
    },
};
